<template>
  <v-container class="quick-actions-section">
    <div class="section-header text-center mb-12">
      <h2 class="section-title">Quick Actions</h2>
      <p class="section-subtitle">Jump right into the most common tasks</p>
    </div>
    
    <v-row>
      <v-col
        v-for="(action, index) in quickActions"
        :key="action.id"
        cols="12"
        sm="6"
        md="4"
      >
        <action-card
          :title="action.title"
          :description="action.description"
          :icon="action.icon"
          :route="action.route"
          :color="action.color"
          :delay="index * 100"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ActionCard from './ActionCard.vue';

export default {
  name: 'QuickActions',
  
  components: {
    ActionCard
  },
  
  data() {
    return {
      quickActions: [
        {
          id: 'create-config',
          title: 'Create Configuration',
          description: 'Set up a new automation rule',
          icon: 'mdi-plus-circle',
          route: '/automation-configs',
          color: 'primary'
        },
        {
          id: 'view-unapproved',
          title: 'Review Orders',
          description: 'Check pending purchase orders',
          icon: 'mdi-clipboard-check',
          route: '/purchase-orders/unapproved',
          color: 'warning'
        },
        {
          id: 'view-dashboard',
          title: 'View Dashboard',
          description: 'See automation performance',
          icon: 'mdi-view-dashboard',
          route: '/automation-dashboard',
          color: 'success'
        },
        {
          id: 'manage-suppliers',
          title: 'Manage Suppliers',
          description: 'Update supplier information',
          icon: 'mdi-truck',
          route: '/suppliers',
          color: 'info'
        },
        {
          id: 'view-history',
          title: 'Order History',
          description: 'View past automated orders',
          icon: 'mdi-history',
          route: '/purchase-orders',
          color: 'secondary'
        },
        {
          id: 'settings',
          title: 'Settings',
          description: 'Configure notifications & preferences',
          icon: 'mdi-cog',
          route: '/settings/reorder-parameters',
          color: 'grey darken-1'
        }
      ]
    };
  }
};
</script>

<style scoped>
.quick-actions-section {
  padding: 80px 0;
  background: #f5f5f5;
  position: relative;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 16px;
}

.section-subtitle {
  font-size: 1.2rem;
  color: #546e7a;
  font-weight: 300;
}

@media (max-width: 960px) {
  .quick-actions-section {
    padding: 60px 0;
  }
  
  .section-title {
    font-size: 2rem;
  }
}
</style> 